import Grid from '../../../../../../components/Table/Grid';
import { GridContainerProps } from '../types';

export function GridContainer({
  columns,
  columnVisibilityModel,
  columnOrder,
  setColumnOrder,
  view,
  source,
  tab,
  searchItems,
  isEvidence,
  isMapping,
  setTotalResults,
  onData,
  getFilterValueRef,
  defaultFilterValue,
  sourceWeights,
  isInvalidSource,
}: GridContainerProps) {
  if (!columns) return null;

  if (isInvalidSource) {
    return (
      <div className="text-center text-gray-500 italic p-6">
        <strong>{source}</strong> is not a source for <strong>{tab}</strong>
      </div>
    );
  }

  return (
    <Grid
      columns={columns}
      columnVisibilityModel={columnVisibilityModel}
      columnOrder={columnOrder}
      setColumnOrder={setColumnOrder}
      view={view}
      source={source}
      tab={tab}
      searchItems={searchItems}
      isEvidence={isEvidence}
      isMapping={isMapping}
      setTotalResults={setTotalResults}
      onData={onData}
      getFilterValueRef={getFilterValueRef}
      defaultFilterValue={defaultFilterValue}
      sourceWeights={sourceWeights}
    />
  );
}